module.exports = __webpack_public_path__ + "static/media/angryActive.5971ca2a.svg";